import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        upload_code: null
    },

    mutations: {
        setCode(state, code) {
            state.upload_code = code;
        }
    },

    actions: {
        getCode({ commit }) {
            return HTTP.get('/admin/images/upload_code')
                .then(resp => commit('setCode', resp.data.code))
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/image.js